import { render, staticRenderFns } from "./SavedPdfs.vue?vue&type=template&id=3f5e9b72&scoped=true&"
import script from "./SavedPdfs.vue?vue&type=script&lang=js&"
export * from "./SavedPdfs.vue?vue&type=script&lang=js&"
import style0 from "./SavedPdfs.vue?vue&type=style&index=0&id=3f5e9b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5e9b72",
  null
  
)

export default component.exports